export default __webpack_public_path__ + "static/media/wizall.add6e8e1.png";